(function() {
	"use strict";

	/**
	 *
	 *	Handles Stres
	 *	behaves like a datastore
	 *
	 */
	angular.module("ATMGApi")
    .service("Api.Store", ApiStore );

  ApiStore.$inject = ["ApiQuery", "ATMGConf", "$q", "$window", "OracleStatusMonitorService"];

  function ApiStore(ApiQuery, Conf, $q, $window, OracleStatus) {

		/**
		*	Stuff this object with cache, use endpoint + JSON.stringified filter as index
		*/
		var cache = {}

		/**
		*	Store status representation (load stack)
		*/
		var status = (function() {
			var loadStack = 0;
			return {
				loading: false,
				load: function(item) {
					loadStack++;
					this.loading = true;
				},
				loaded: function(item) {
					loadStack--;
					var self = this;
					if (loadStack === 0)  {
							self.loading = false;
					}
				},
				isLoading: function() {
					return loadStack === 0;
				},
			}
		})()

		/**
		*	Handle Store loading operations
		*/
		function loading(item) {
			context.beingLoaded[item] = true;
			status.load();
		}

		function loaded(item) {
			context.beingLoaded[item] = false;
			status.loaded();
		}

		/**
		*	Available contexts
		*
		*	this way we can store different context and switch between them
		*	providing a more flexible way to handle context-specific details
		*/
		var contexts = {
			repairs: {
				regex: /repairs/,
				name: 'repairs',
				filterName: 'repairs',
				loading: 0,
				label: "Repairs and Services",
				beingLoaded: {
					products: false,
					pagination: false,
					categories: false
				},
				endpoints: {
					products: 'store/items/services',
					pagination: 'store/pagination/services',
					categories: 'store/categories/services'
				}
			},
			products: {
				regex: /products/,
				name: 'products',
				filterName: 'products',
				label: "Products",
				loading: 0,
				beingLoaded: {
					products: false,
					pagination: false,
					categories: false
				},
				endpoints: {
					products: 'store/items/products',
					pagination: 'store/pagination/products',
					categories: 'store/categories/products'
				}
			}
		};

		/**
		*	Items being exported
		*/
		var store = {
			products: undefined,
			categories: undefined,
			pagination: undefined,
			product: undefined,
		}

		var context = contexts.products;

		/**
		*	switchContext
		*
		*	Switch store context
		*
		*/
		function switchContext(newContext) {

			// keep it open
			_.forEach( contexts, function( contextDetails, contextName, contexts ) {
				if (contextDetails.regex.test(newContext)) {
					context = contextDetails;
				}
			})

			return context;
		}

		/**
		*	checkCache
		*
		*	Checks if requested endpoint and filters combination has been stored already
		*/
		function cacheCheck(cacheSlot) {
			if (cache[cacheSlot]) {
				return cache[cacheSlot];
			} else {
				return false;
			}
		}

		function cacheStore(cacheSlot, data) {
			cache[cacheSlot] = data;
		}

		/**
		*	getCategories
		*
		*	Fetch categories based on current set
		*
		*/
		function getCategories(filters, forceReload, Loader = null) {
			return getCachedOrRequest('categories', _.clone(_.omit(filters, ['page', 'take', 'sortBy', 'sortOrder'])), forceReload, Loader);
		}

		/**
		 *	getProducts
		*/
		function getProducts(filters, forceReload) {
			return getCachedOrRequest('products', filters, forceReload);
		}

		/**
		 *	getPagination
		*/
		function getPagination(filters, forceReload) {
			return getCachedOrRequest('pagination', filters, forceReload);
		}


		/**
		 *	getCachedOrRequest
		 *
		 *	tries to hit the cache or load data via api
		 *
		 *	@param string type ['products', 'categories', 'pagination']  item trying to be fetched
		 *	@param string filters filters object
		 *	@param force forces a cold load
		*/
		function getCachedOrRequest(type, filters, force, Loader = null) {

			var defer = $q.defer();

			var defer = $q.defer();

			if (OracleStatus.get() === false ) {
				if (type == 'categories' && Loader != null) {
					Loader.hide();
				}
				console.warn("Oracle seems to be down, I'm not firing any request.")
				var defer = $q.defer();
				defer.resolve(false);
				return defer.promise;
			}

			// scroll to top no matter what happens
			$window.scrollTo(0, 0);

			var cacheSlot = context.endpoints[type] + encodeURIComponent(JSON.stringify(filters));

			if (cacheCheck(cacheSlot) && !force)  {
				var defer = $q.defer();
				store[type] = cacheCheck(cacheSlot);
				defer.resolve(true);
				if (type == 'categories' && Loader != null) {
					Loader.hide();
				}
				return defer.promise;
			}

			if (context.beingLoaded[type] === false) {
				loading(type);
				return ApiQuery(context.endpoints[type], filters, "GET" )
					.then(function( response ) {
						switch(type){
							case 'products':
								store[type] = parseProducts(response.data.data);
								break;

							default:
								store[type] = response.data.data;
								break;
						}
						cacheStore(cacheSlot, store[type]);
						loaded(type);
						if (type == 'categories' && Loader != null) {
							Loader.hide();
						}
						return store;

					}, function( reason ) {
						loaded(type);
						console.error("Unable to load %s.", type);
					})

			}

			if (type == 'categories' && Loader != null) {
				Loader.hide();
			}
			return defer.promise;

		}


		/**
		*	Fetch a single product
		*/
		function getProduct(slug) {
			store.product = {};
			let p1 =	ApiQuery('store/item-options/' + slug, '', "GET")
				.then(response => {
					store.product.purchase_options = response.data.data;
				})
			let p2 = ApiQuery("store/item/" + slug, "", "GET")
				.then(response => {
					store.product = response.data.data;
				})
			return Promise.all([p1, p2])
				.then(() => {
					return Promise.resolve(store.product)
				})
				.catch(reason => Promise.reject(reason))
		}

		///////////////////////////////	store

		return {

			categories: function() { return store.categories },
			products: function() { return store.products },
			pagination: function() { return store.pagination },
			product: function() { return store.product },
			getCategories: getCategories,
			getProducts: getProducts,
			getPagination: getPagination,
			getProduct: getProduct,
			switchContext: switchContext,
			status: status,
			getInfo: function() {
				return { pageName: context.label }
			},
			getContext: function() {
				return context;
			},
			reset: function() {  //	reset Fetched stuff
				this.collection = {
					productsList: undefined,
					categoriesList: undefined
				};
				return true;
			}
		}
	}

	function parseProducts(products) {
		/**
		*	loop through products and check if images are present
		*/
		_.forEach( products, function( product, key, products ) {
			var product_image = new Image(),
			img_src = "/media/products/images/" + product.item_number + '.jpg'
			product_image.src = img_src;
			product.image = img_src
		} )

		return products;
	}
})()



// WEBPACK FOOTER //
// ./src/app/modules/ATMGApi/services/Store.js